import LogoutIcon from '@mui/icons-material/Logout';
import {IconButton, Tooltip} from '@mui/material';

import constants from '@/config/constant';
import {useAppDispatch, useAppSelector} from '@/store/store-hooks';
import {endSession} from './session-actions';

/**
 * Locks the in-memory direct-auth session. Rendered only when the feature flag
 * is on and a session is unlocked; clicking clears the key and the SessionGuard
 * redirects to /login on the next render. See this.i wqz7k3mnbp.
 */
export default function LogoutButton() {
  const enabled = constants.DIRECT_AUTH_ENABLED;
  const unlocked = useAppSelector(s => s.authSession.unlocked);
  const dispatch = useAppDispatch();

  if (!enabled || !unlocked) return null;

  return (
    <Tooltip title="Lock session">
      <IconButton
        color="inherit"
        aria-label="lock session"
        onClick={() => endSession(dispatch)}
      >
        <LogoutIcon />
      </IconButton>
    </Tooltip>
  );
}
